import {RouteHelper, RouteInfo} from "../../route/RouteHelper";

export const SidebarItemsType = {
    COLLAPSE: "COLLAPSE",
    SIMPLE_ITEM: "SIMPLE_ITEM",
    HEADER_ITEM: "HEADER_ITEM",
}


export const advanceSidebarItemTypes = {
    COLLAPSE: "COLLAPSE",
    SIMPLE_ITEM: "SIMPLE_ITEM",
    SIMPLE_CHILD: "SIMPLE_CHILD",
    ROOT_ITEM: "ROOT_ITEM",
}

export const advanceSidebarItems = [
    {
        info: RouteHelper.Dashboard,
        type: advanceSidebarItemTypes.SIMPLE_ITEM,
        parent: null
    }, {
        info: RouteHelper.Union,
        type: advanceSidebarItemTypes.SIMPLE_ITEM,
        parent: null
    }, {
        info: RouteHelper.CashInfo,
        type: advanceSidebarItemTypes.SIMPLE_ITEM,
        parent: null
    },
    {
        info: RouteHelper.Groups,
        type: advanceSidebarItemTypes.ROOT_ITEM,
        parent: null
    },
    {
        type: advanceSidebarItemTypes.SIMPLE_ITEM,
        info: RouteHelper.Users,
        parent: null
    },
    {
        info: RouteHelper.GroupsList,
        type: advanceSidebarItemTypes.SIMPLE_CHILD,
        parent: RouteHelper.Groups
    },
    {
        info: RouteHelper.GroupsReport,
        type: advanceSidebarItemTypes.SIMPLE_CHILD,
        parent: RouteHelper.Groups
    },
    {
        type: advanceSidebarItemTypes.ROOT_ITEM,
        info: RouteHelper.Managers,
        parent: null
    },
    {
        type: advanceSidebarItemTypes.SIMPLE_CHILD,
        info: RouteHelper.ManagersList,
        parent: RouteHelper.Managers
    },
    {
        type: advanceSidebarItemTypes.SIMPLE_CHILD,
        info: RouteHelper.ManagersAccess,
        parent: RouteHelper.Managers
    },
    {
        type: advanceSidebarItemTypes.ROOT_ITEM,
        info: RouteHelper.Accounts,
        parent: null
    },
    {
        type: advanceSidebarItemTypes.SIMPLE_CHILD,
        info: RouteHelper.AccountsList,
        parent: RouteHelper.Accounts
    },
    {
        type: advanceSidebarItemTypes.SIMPLE_CHILD,
        info: RouteHelper.AccountsTransactionsList,
        parent: RouteHelper.Accounts
    },
    {
        type: advanceSidebarItemTypes.SIMPLE_CHILD,
        info: RouteHelper.AccountsCheckout,
        parent: RouteHelper.Accounts
    },
    {
        type: advanceSidebarItemTypes.ROOT_ITEM,
        info: RouteHelper.Loans,
        parent: null
    },
    {
        type: advanceSidebarItemTypes.SIMPLE_CHILD,
        info: RouteHelper.LoansList,
        parent: RouteHelper.Loans
    },
    {
        type: advanceSidebarItemTypes.SIMPLE_CHILD,
        info: RouteHelper.InstallmentsList,
        parent: RouteHelper.Loans
    },
    {
        type: advanceSidebarItemTypes.SIMPLE_CHILD,
        info: RouteHelper.LoansRequests,
        parent: RouteHelper.Loans
    },
    {
        type: advanceSidebarItemTypes.SIMPLE_ITEM,
        info: RouteHelper.TransactionsList,
        parent: null,
    },
    {
        type: advanceSidebarItemTypes.ROOT_ITEM,
        info: RouteHelper.CostAndRevenue,
        parent: null
    },
    {
        type: advanceSidebarItemTypes.SIMPLE_CHILD,
        info: RouteHelper.CashTransactions,
        parent: RouteHelper.CostAndRevenue
    },
    {
        type: advanceSidebarItemTypes.SIMPLE_CHILD,
        info: RouteHelper.CostAndRevenueCategory,
        parent: RouteHelper.CostAndRevenue
    },
    {
        type: advanceSidebarItemTypes.SIMPLE_CHILD,
        info: RouteHelper.TagList,
        parent: RouteHelper.CostAndRevenue
    },
    {
        type: advanceSidebarItemTypes.SIMPLE_ITEM,
        info: RouteHelper.FeedBack,
        parent: null
    },
    {
        type: advanceSidebarItemTypes.SIMPLE_ITEM,
        info: RouteHelper.Election,
        parent: null
    },
    {
        type: advanceSidebarItemTypes.SIMPLE_ITEM,
        info: RouteHelper.OtherPayments,
        parent: null
    },
    {
        type: advanceSidebarItemTypes.SIMPLE_ITEM,
        info: RouteHelper.LogsList,
        parent: null
    },
]

export const sideBarListItemsClerk = [
    {
        info: "خانه",
        type: SidebarItemsType.HEADER_ITEM
    }, {
        info: RouteInfo.Dashboard,
        type: SidebarItemsType.SIMPLE_ITEM
    }, {
        info: "مدیریت",
        type: SidebarItemsType.HEADER_ITEM
    }, {
        info: RouteInfo.ManagersAccess,
        type: SidebarItemsType.SIMPLE_ITEM
    }, {
        info: RouteInfo.ManagersList,
        type: SidebarItemsType.SIMPLE_ITEM
    }, {
        info: "کامپوننت های آماده",
        type: SidebarItemsType.HEADER_ITEM
    }, {
        info: RouteInfo.DefaultListPage,
        type: SidebarItemsType.SIMPLE_ITEM
    }, {
        info: RouteInfo.DefaultInputsPage,
        type: SidebarItemsType.SIMPLE_ITEM
    }, {
        info: RouteInfo.Category,
        type: SidebarItemsType.SIMPLE_ITEM
    }, {
        info: RouteInfo.Exam,
        type: SidebarItemsType.SIMPLE_ITEM
    }, {
        info: "فایل ها",
        type: SidebarItemsType.HEADER_ITEM
    }, {
        info: RouteInfo.Files,
        type: SidebarItemsType.SIMPLE_ITEM
    }, {
        info: "نمودار ها",
        type: SidebarItemsType.HEADER_ITEM
    }, {
        info: RouteInfo.Charts,
        type: SidebarItemsType.SIMPLE_ITEM
    }, {
        info: RouteInfo.SimpleBarChart,
        type: SidebarItemsType.SIMPLE_ITEM
    }, {
        info: RouteInfo.PieChartWithPaddingAngle,
        type: SidebarItemsType.SIMPLE_ITEM
    }, {
        info: RouteInfo.SimplePieChart,
        type: SidebarItemsType.SIMPLE_ITEM
    }, {
        info: RouteInfo.VerticalBarChart,
        type: SidebarItemsType.SIMPLE_ITEM
    }, {
        info: RouteInfo.DoughnutChart,
        type: SidebarItemsType.SIMPLE_ITEM
    }, {
        info: RouteInfo.PieChart,
        type: SidebarItemsType.SIMPLE_ITEM
    }, {
        info: "اسناد",
        type: SidebarItemsType.HEADER_ITEM
    }, {
        info: RouteInfo.ReleaseDocuments,
        type: SidebarItemsType.SIMPLE_ITEM
    }, {
        info: RouteInfo.AppVersionList,
        type: SidebarItemsType.SIMPLE_ITEM
    },


]


